<template>
  <modal
    :show="showImportModal"
    @close="closeImportModal"
  >
    <template v-slot:header>
      <h3>{{ $t("import.bopModel.title") }}</h3>
    </template>
    <template>
      <div class="d-flex flex-column">
        <!-- traduction -->
        <b-row>
          <b-col md="12">
            <div
              v-if="!isLoadingImportModal"
              class="login-form"
            >
              <span class="login-form-label">{{
                $t("import.bopModel.description")
              }}</span>
              <b-form-file
                v-model="file"
                :browse-text="$t('import.bopModel.browse')"
                :drop-placeholder="$t('import.bopModel.drop')"
                :placeholder="$t('import.bopModel.choose')"
                accept=".xlsx,.csv"
                class="mt-3"
                >{{ $t("import.bopModel.import") }}
              </b-form-file>
            </div>
            <div
              v-else
              class="text-center"
              style="width: 100%; margin-top: 0.5em"
            >
              <b-spinner
                label="Text Centered"
                variant="primary"
              ></b-spinner>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="errorReport.length">
          <b-col md="12">
            <b-card class="default error-import mt-3">
              <b-col>
                <h6 class="title">{{ $t("import.missingEntriesTitle") }}</h6>
                <p style="margin-top: 0.5em">{{ errorReport }}</p>
              </b-col>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </template>
    <template v-slot:footer>
      <b-button
        variant="secondary"
        @click="closeImportModal"
      >
        {{ $t("import.cancel") }}
      </b-button>
      <b-button
        :disabled="isValidateDisabled || !file"
        variant="primary"
        @click="validate"
      >
        {{ $t("import.validate") }}
      </b-button>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import ImportService from "@/services/ImportService";

@Component({
  components: {
    Modal: () => import("@/components/Shared/Modal.vue"),
  },
})
export default class ImportBopModelModal extends Vue {
  public showImportModal: boolean = false;
  private file = null;
  private isLoadingImportModal: Boolean = false;
  private errorReport: string = "";
  private isValidateDisabled: boolean = false;

  public openImportModal() {
    this.showImportModal = true;
  }

  public closeImportModal() {
    this.file = null;
    this.errorReport = "";
    this.isValidateDisabled = false;
    if (!this.isLoadingImportModal) this.showImportModal = false;
  }

  private async validate() {
    if (this.isValidateDisabled || !this.file) return;
    this.isValidateDisabled = true;
    const formData = new FormData();
    this.errorReport = "";
    formData.append("File", this.file || "");

    this.isLoadingImportModal = true;
    try {
      const result = await ImportService.importBopModel(formData);

      this.isLoadingImportModal = false;
      if (result?.status == 200) {
        if (result.data != "Success") {
          this.errorReport = result.data;
        } else {
          this.$notify({
            group: "global",
            type: "success",
            title: this.$t("import.bopModelSuccessful.title").toString(),
            text: this.$t("import.bopModelSuccessful.description").toString(),
          });
          this.closeImportModal();
        }
      }
    } catch (e: any) {
      this.isLoadingImportModal = false;
      let text = this.$t("bopModelSetup.bopModelError.text").toString();
      if (e.response.status === 400) {
        if (e.response.data === "notValidFileFormat") {
          text = this.$t("import.bopModelNotValidFormat").toString();
        }
      }
      this.$notify({
        group: "global",
        type: "error",
        title: this.$t("import.bopModelError.title").toString(),
        text,
      });
    } finally {
      this.isValidateDisabled = false;
    }
  }
}
</script>

<style scoped="scss"></style>
